export function extractDnsMxRecords(records) {
  return (records || []).reduce((mxRecords, record) => {
    const {name, type} = record;
    if (type === 'MX') {
      const values = Array.isArray(record.value) ? record.value : [record.value];
      mxRecords.push(
        ...values.map(rawValue => {
          const [priority, value] = String(rawValue || '').split(' ');
          return {name, type, priority, value};
        })
      );
    }
    return mxRecords;
  }, []);
}
